import { Head, Link } from "@inertiajs/react"

import { withPublicLayout } from "@/layouts/public-layout"
import { rootPath, submitPath } from "@/routes"

interface Props {
  stats: { total: number; checks_last_day: number }
}

export default function About({ stats }: Props) {
  return (
    <>
      <Head title="About" />
      <article className="prose prose-stone dark:prose-invert prose-a:text-brand prose-headings:tracking-tight mx-auto max-w-2xl px-4 pt-14 sm:px-6">
        <h1>What is a single-serving site?</h1>
        <p className="lead">
          A website with its own domain that does exactly one thing. It answers
          one question, tells one joke, or does one job, then gets out of the
          way.
        </p>
        <p>
          <a href="https://isitchristmas.com/">isitchristmas.com</a> says NO 364
          days a year. Others count down, generate, or exist to make one person
          laugh. Kottke gave the genre its name in 2008, but people were
          registering domains for one idea well before that.
        </p>

        <h2>How this directory works</h2>
        <p>
          We track {stats.total.toLocaleString()} sites. Each one is loaded in
          headless Chrome at 1280×800. The capture waits for the network to go
          quiet and the fonts to load, then waits a little longer for animations
          to settle. Blank frames get a second, slower attempt.
        </p>
        <p>
          A worker checks every site about once an hour. We ran{" "}
          {stats.checks_last_day.toLocaleString()} checks in the last 24 hours.
          A site counts as down after two failures in a row, and as gone after a
          month of failures or once its domain stops resolving. Parked or
          for-sale domains get flagged too, since those return a happy 200 that
          a naive monitor would call up.
        </p>
        <p>
          Gone sites keep their place in the directory. We screenshot their best
          Wayback Machine snapshot and link you to the archive, because 30 years
          of internet history is worth keeping.
        </p>

        <h2 id="bot">For site owners</h2>
        <p>
          Our checker identifies itself as{" "}
          <code>SingleServingSiteDirectory/1.0</code> in its user agent. It
          makes one GET request per hour and reads at most 256KB. If you would
          rather not be listed, or want your entry updated,{" "}
          <Link href={submitPath()}>
            send us a note through the submit form
          </Link>
          .
        </p>

        <h2>Credit</h2>
        <p>
          The directory was seeded from{" "}
          <a href="https://singleservingsites.cool/">singleservingsites.cool</a>
          , huphtur&apos;s hand-curated list. Go visit it. Then{" "}
          <Link href={rootPath()}>come back and browse</Link>.
        </p>
      </article>
    </>
  )
}

About.layout = withPublicLayout
